import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function RandomRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/random").then((r) => navigate(`/article/${r.data.slug}`, { replace: true })).catch(() => navigate("/"));
  }, [navigate]);
  return <div className="flex min-h-[50vh] items-center justify-center text-sm" style={{ color: "var(--arc-text-2)" }}>Discovering forbidden knowledge…</div>;
}
